<template>
  <div class="menu-container" :class="{ mobile: device === 'mobile' }">
    <div class="first-menu" v-if="canShowModule(['workplace', 'mini_powerpack', 'open_frame', 'industrial'])">
      <menu-item :label="$t('powerpack.menu.circuit')" tooltip-key="tooltip_hydraulic_circuit"  v-if="canShowModule(['mini_powerpack'])">
        <form class="radio-container">
          <input type="radio" :value="2" v-model="valveType" name="circuit" id="radio-1"
                 @click="pushDataLayer({
                    step: gaData.steps.step4,
                    interaction_type: gaData.interactionTypes.click,
                    field: 'hydraulisch circuit',
                    value: gaData.undefined,
                    build_id: gaData.undefined
                  })"
                 checked="checked"><label for="radio-1">{{ $t('powerpack.menu.double') }}</label>
          <input type="radio" :value="1" v-model="valveType" name="circuit" id="radio-2"
                 @click="pushDataLayer({
                    step: gaData.steps.step4,
                    interaction_type: gaData.interactionTypes.click,
                    field: 'hydraulisch circuit',
                    value: gaData.undefined,
                    build_id: gaData.undefined
                  })"><label for="radio-2">{{ $t('powerpack.menu.single') }}</label>
        </form>

        <input-dropdown :options="circuits" :value="circuitIndex" @change="handleCircuitInput"/>
      </menu-item>

      <menu-item v-if="canShowModule(['mini_powerpack', 'industrial']) && valveType === 1" :label="$t('powerpack.menu.returnThrottling')"
                 tooltip-key="tooltip_retour_forging">

        <input-dropdown
            :options="throttlingOptions"
            :value="returnThrottling"
            @change="handleThrottling"/>
      </menu-item>

      <div class="valves-block">
        <valves-list
            v-if="canShowModule(['workplace', 'mini_powerpack', 'open_frame', 'industrial']) || this.bmotor.id !== 51"
            tooltip-key="tooltip_valves"
            :label="$t('powerpack.menu.valves')"
            :valves="allValves"
            @onValveClick="openPopup"
            @onValveCreate="openPopupAfterCreate">
        </valves-list>

        <popup-valve
            v-if="popup !== -1"
            :selectedValveIndex="popup"
            :additional-valves="allAdditionalValves"
            @confirm="confirmPopup"
            @close="closePopup"/>
      </div>

    </div>

  </div>
</template>

<script>
import MenuItem from './MenuItem'
import MenuItemNumber from './MenuItemNumber'
import MenuItemToggle from './MenuItemToggle'
import MenuItemAddValve from '../valves/ValvesList'
import MenuItemLanguageButtons from './MenuItemLanguageButtons'
import MenuFrame from './MenuFrame'
import PopupValve from "../../popup/PopupValve";
import MotorSelect from './MotorReselect';
import TankDropdown from './TankDropdown';
import ElectricBoxDropdown from './electricBoxDropdown';
import PumpDropdown from './PumpDropdown';
import CoddinButton from "../../input/Button";
import CoddinCheckbox from "../../input/CheckboxPowerpackOptions";
import ArdinCheckbox from "../../input/Checkbox";
import showModuleMixin from '../../../mixins/showModuleMixin';
import {mapGetters, mapMutations, mapState} from 'vuex'
import OilCoolerDropdown from "./OilCoolerDropdown";
import InputDropdown from "../../input/Dropdown";
import WheelsCheckbox from "./WheelsCheckbox";
import CoolerCheckbox from "./CoolerCheckbox";
import ValvesList from "@/components/step2/valves/ValvesList";
import googleAnalyticsMixin from '@/mixins/googleAnalyticsMixin';

export default {
  name: 'Menu',

  components: {
    InputDropdown,
    OilCoolerDropdown,
    CoddinButton,
    CoddinCheckbox,
    ArdinCheckbox,
    PopupValve,
    MenuItem,
    MenuItemNumber,
    MenuItemToggle,
    MenuItemAddValve,
    MenuItemLanguageButtons,
    MenuFrame,
    MotorSelect,
    TankDropdown,
    PumpDropdown,
    ElectricBoxDropdown,
    WheelsCheckbox,
    CoolerCheckbox,
    ValvesList
  },

  mixins: [showModuleMixin, googleAnalyticsMixin],

  data() {
    return {
      popup: -1,
    }
  },
  computed: {
    ...mapGetters({
      bmotor: 'build/getMotor',
      options: 'workplaceOptions/getAll',
      powerpackOptions: 'powerpackOptions/getAll',
      device: 'getDevice',
    }),
    ...mapState({
      selectedMotor: state => state.preference.selectedMotor,
      additionalValves: state => state.additionalValves.all,
      valves: state => state.build.valves,
      pumps: state => state.pumps.all,
      motors: state => state.motors.all,
      allCircuits: state => state.circuits.all,
      tankIndex: state => state.build.tank,
      byTankId: state => state.tanks.byId,
      types: state => state.preference.motorOptions,
      support: state => state.build.support,
      valveType: state => state.build.valveType,
      allAdditionalValves: state => state.additionalValves.all,
      allValves: state => state.build.valves,
      circuitIndex: state => state.build.circuit,
      btwValue: state => state.preference.BTW | 0
    }),
    valveType: {
      get() {
        return this.$store.state.build.valveType;
      },
      set(type) {
        this.$store.dispatch('build/setValveType', type);
        this.unsetAllreturnThrottlings();
      }
    },
    circuits() {
      return this.allCircuits
          .filter(circuit => {
            return circuit.valve_type === this.valveType;
          }).map(circuit => {
            return {
              key: circuit.id,
              value: this.translate(circuit.name),
            }
          });
    },
    circuitIndex: {
      get() {
        return this.$store.state.build.circuit;
      },
      set(val) {
        this.$store.commit('build/setCircuit', val)
      }
    },
    allReturnThrottlings() {
      return this.powerpackOptions.filter(powerpackOption => powerpackOption.type === 'back_smoring');
    },
    returnThrottling() {
      const selectedReturnThrottling = this.allReturnThrottlings.find(
          powerpackOption => powerpackOption.selected === true
      );
      return selectedReturnThrottling ? selectedReturnThrottling.id : null;
    },

    throttlingOptions() {
      const data = [
        {
          key: null,
          value: this.$t('powerpack.menu.defaultThrottlingOption')
        }];

      this.allReturnThrottlings.forEach(powerpackOption => {
        data.push({
          key: powerpackOption.id,
          value: powerpackOption.name.nl,
        });
      });

      return data;
    },

    getMaxPressure() {
      return this.$store.state.preference.pressure;
    },
    activeTank() {
      let id = this.tankIndex > 0 ? this.tankIndex : 1;
      return this.byTankId[id];
    },
  },
  methods: {
    ...mapMutations({
      workplaceStore: 'workplaceOptions/setSelected',
      powerpackStore: 'powerpackOptions/setSelected',
      openFrameStore: 'openFrameOptions/setSelected',
      setSupport: 'build/setSupport'
    }),
    handleChange(e) {
      const bool = e.target.value === 'true'; //make sure always a bool
      const index = parseInt(e.target.dataset.index);

      this.workplaceStore({index, bool});
    },
    handleSupportInput({index, bool}) {
      this.powerpackStore({index, bool});
    },
    handleCircuitInput(id) {
      this.pushDataLayer({
        step: this.gaData.steps.step4,
        interaction_type: this.gaData.interactionTypes.click,
        field: 'hydraulisch circuit',
        value: this.gaData.undefined,
        build_id: this.gaData.undefined
      })
      this.$store.commit('build/setCircuit', id);
    },

    handleThrottling(key) {
      this.unsetAllreturnThrottlings();

      if (key !== null) {
        const returnThrottling = this.allReturnThrottlings.find(returnThrottling => returnThrottling.id === key);
        this.$store.commit('powerpackOptions/toggleSelected', returnThrottling);
      }
    },

    unsetAllreturnThrottlings() {
      this.allReturnThrottlings.forEach(
          returnThrottling => {
            if (returnThrottling.selected) {
              this.$store.commit('powerpackOptions/toggleSelected', returnThrottling);
            }
          }
      );
    },

    closePopup() {
      this.popup = -1;
    },
    confirmPopup() {
      this.popup = -1;
    },
    openPopup(index) {
      this.popup = index;
    },
    openPopupAfterCreate(index) {
      this.popup = index;
    },

    selectMotor(val) {
      this.$store.commit('build/setMotor', val)
    },
    setPressure(val) {
      this.$store.commit('preference/updateSafetyPressure', val);
      this.safetyPressure = val;
    },
    setValves(val) {
      this.$store.dispatch('build/setValveType', val)
    },
  },
}
</script>

<style lang="scss">
.selection-body {
  .menu-container {
    &.mobile {
      width: 100%;
      margin-bottom: 0;
    }
  }
}

.radio-container {
  border-radius: 50px;
  border: 2px solid #EBEBEB;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  background-color: white;
  margin-bottom: 10px;

  label {
    cursor: pointer;
    display: flex;
    justify-content: center;
    font-size: 12px;
    margin: 0;
    border-radius: 25px;
    width: 50%;
    padding: 9px;
    user-select: none;
    font-family: neue-haas-grotesk-display, sans-serif;
  }

  input[type="radio"] {
    display: none;


    &:checked + label {
      background-color: #3DB0C7;
      color: white;
    }
  }
}
</style>
